export const canonicalName = 'currency-field';
export const currencyFieldCurrencySignPosition = {
    start: 'start',
    end: 'end'
};
/* Interface defaults. */
export const currencyFieldManagerConfigDefaults = {
    currencySign: '$',
    currencySignPosition: currencyFieldCurrencySignPosition.start,
    decimalSeparator: '.',
    max: undefined,
    maximumFractionDigits: 2,
    min: undefined,
    minimumDecimalPrecision: 2,
    minimumFractionDigits: 0,
    thousandsSeparator: ',',
    useMaskedValue: false
};
export const fsCurrencyFieldDefaults = {
    ...currencyFieldManagerConfigDefaults,
    /*
      Base currency field confiration.
      TODO: Migrate this to the text-field core package.
    */
    autofocus: false,
    compact: false,
    disabled: false,
    helperText: '',
    hideLabel: false,
    name: '',
    id: '',
    noValidate: false,
    placeholder: '',
    readOnly: false,
    required: true,
    showError: false
};
//# sourceMappingURL=types.js.map